import angular from 'angular';
import kformUtils from '~/components/kform/utils/kform-utils';
import template from './checkbox.html';

const checkboxConfig = /* @ngInject */ (
	/** @type {any} */ KformComponentsProvider,
) => {
	KformComponentsProvider.register('checkbox', {
		title:      'Check Box',
		template,
		tableView:  (/** @type {any} */ data) => (data ? 'Yes' : 'No'),
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options?.building) {
				return;
			}

			/** @type {any} */
			const boolean = {
				[$scope.component?.trueValue ?? true]: true,
				[$scope.component?.falseValue ?? false]: false,
			};

			const defaultValue = $scope.component?.defaultValue === undefined
				? false : boolean[$scope.component.defaultValue];

			// FA-850 - Ensure the checked value is always a boolean object when loaded, then unbind the watch.
			if ($scope.component?.inputType === 'checkbox') {
				// FOR-440 - Only use the default value if the data isn't defined.
				// On the first load, attempt to set the default value.
				$scope.data[$scope.component.key] = Object.prototype.hasOwnProperty.call(
					$scope.data, $scope.component.key,
				) && Object.prototype.hasOwnProperty.call(
					boolean, $scope.data[$scope.component.key],
				)
					? boolean[$scope.data[$scope.component.key]]
					: defaultValue;

				$scope.$watch(`data.${$scope.component.key}`, () => {
					if (!$scope.data || !$scope.component.key) {
						return;
					}

					// If the component is required, and its current value is false, delete the entry.
					if (
						$scope.component.validate?.required
						&& boolean[$scope.data[$scope.component.key]] === false
					) {
						delete $scope.data[$scope.component.key];
					}
				});
			}

			$scope.topOrLeftOptionLabel = kformUtils.labelPositionWrapper(kformUtils.topOrLeftOptionLabel);
			$scope.getOptionLabelStyles = kformUtils.labelPositionWrapper(kformUtils.getOptionLabelStyles);
			$scope.getOptionInputStyles = kformUtils.labelPositionWrapper(kformUtils.getOptionInputStyles);

			$scope.changeValue = () => {
				if (typeof $scope.component?.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus: false,
			input:     true,
			inputType: 'checkbox',
			tableView: true,
			// This hides the default label layout so we can use a special inline label
			hideLabel:     false,
			label:         '',
			dataGridLabel: false,
			key:           'checkboxField',
			defaultValue:  false,
			protected:     false,
			persistent:    true,
			hidden:        false,
			name:          '',
			value:         '',
			clearOnHide:   true,
			trueValue:     undefined,
			falseValue:    undefined,
			validate:      {
				card: '0-1',
			},
			conditional:   {
				show: null,
				when: null,
				eq:   '',
			},
			event:         {
				onChange: null,
			},
			kdata:         {
				submit: true,
			},
		},
		icon:       'fa fa-check-square',
		onEdit:     /* @ngInject */ (/** @type {any} */ $scope) => {
			$scope.inputTypes = [
				{
					name:  'checkbox',
					title: 'Checkbox',
				},
				{
					name:  'radio',
					title: 'Radio',
				},
			];

			$scope.labelPositions = [
				{
					value: 'top',
					title: 'Top',
				},
				{
					value: 'left',
					title: 'Left',
				},
				{
					value: 'right',
					title: 'Right',
				},
				{
					value: 'bottom',
					title: 'Bottom',
				},
			];

			if (!$scope.component.labelPosition) {
				$scope.component.labelPosition = 'right';
			}
		},
		views:      [
			{
				name:     'Display',
				template: 'kform/components/checkbox/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/checkbox/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(checkboxConfig);
